// extracted by mini-css-extract-plugin
module.exports = {"boxThree":"UICheckboxWewSquare_boxThree__3eZao","boxFour":"UICheckboxWewSquare_boxFour__3x-6T"};